var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1),_c('remote-js',{attrs:{"src":"//at.alicdn.com/t/font_2214107_mdhrr1r1xqi.js"}}),_c('VersionUpdatePrompt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }